function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.971 7.272a3.917 3.917 0 0 0 1.645-2.183 7.257 7.257 0 0 1-2.377.958A3.643 3.643 0 0 0 15.508 4.8c-2.066 0-3.741 1.767-3.741 3.946 0 .31.031.611.095.9C8.753 9.48 5.996 7.91 4.15 5.521a4.103 4.103 0 0 0-.507 1.985c0 1.368.66 2.576 1.665 3.285-.613-.02-1.19-.2-1.696-.493v.049c0 1.912 1.29 3.508 3.003 3.87a3.483 3.483 0 0 1-.987.138c-.24 0-.476-.024-.703-.07.475 1.567 1.857 2.71 3.495 2.74a7.265 7.265 0 0 1-5.54 1.636 10.204 10.204 0 0 0 5.736 1.772c6.884 0 10.646-6.014 10.646-11.23 0-.17-.002-.341-.01-.51a7.822 7.822 0 0 0 1.868-2.043 7.173 7.173 0 0 1-2.149.62z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/twitter.4867c994.svg";
export { SvgComponent as ReactComponent };